package views.componentes

import androidx.compose.runtime.Composable
import androidx.compose.runtime.MutableState
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import ffSpan
import org.jetbrains.compose.web.dom.*
import utils.*
import ffValidar
import org.jetbrains.compose.web.attributes.*
import org.jetbrains.compose.web.css.*
import utils.ff.Companion.giClick
import utils.ff.Companion.println0

//import utils.ff.Companion.giClick


class table1 {

    //val _t = "tab1"
    var width = 0
    var tipo = ""
    var alterar = ""
    var campo = ""
    var titulo = ""

    //var click = -1
    var lista01: Array<dynamic>? = null
    var fontSmallTable = 12.px

    fun add(_width: Int, _tipo: String, _alterar: String, _campo: String, _titulo: String): table1 {

        this.tipo = _tipo
        this.width = _width
        this.alterar = _alterar
        this.campo = _campo
        this.titulo = _titulo
        //this.click = -1
        return this
    }

    @Composable
    public fun ffTable1(
        _lcol: List<table1>,
        _json: String = "",
        _table1Controler: MutableState<String>,
        _arrayDynamic: Array<dynamic>? = null,
        _tbTipo: String = "Black" //Mesclado, Black, White
    ): Unit {
        //public fun ffTable1(_lcol: List<table0>, _sJson: String): Unit {

        //_table1Click.value = ""
        //println0("zuzaaqui 123")
        //println0(_sJson)
        //ff.println0(_lcol)
        //ff.println0(lista01!!)
        //giClick = -1

        var vararg1 = "\"table\", \"table-sm\""

        return Div({ classes("form-group"); style { fontSize(fontSmallTable) } }) {

            if (_tbTipo.equals("Black")) {
                Table({
                    classes("table", "table-sm", "table-dark"); id(_table1Controler.id()); style {
                    fontSize(fontSmallTable)
                }
                }) {
                    ffTable1item("Black", _lcol, _json, _arrayDynamic, _table1Controler)
                }
            } else if (_tbTipo.equals("Mesclado")) {
                Table({
                    classes("table", "table-sm", "table-striped", "table-centered", "mb-0");
                    id(_table1Controler.id()); style { fontSize(fontSmallTable) };
                }) {
                    ffTable1item("Mesclado", _lcol, _json, _arrayDynamic, _table1Controler)
                }
            } else {
                Table({ classes("table", "table-sm"); id(_table1Controler.id()); style { fontSize(fontSmallTable) } }) {
                    ffTable1item("Branco", _lcol, _json, _arrayDynamic, _table1Controler)
                }
            }
            //ffJS("use strict")
        }
    }

    @Composable
    private fun ffTable1item(
        _tipo: String, //black, mesclado, null
        _lcol: List<table1>,
        _json: String = "",
        _arrayDynamic: Array<dynamic>? = null,
        _table1Controler: MutableState<String>
    ): Unit {

        //println0("zuza55")
        var sJson = _json
        lista01 = _arrayDynamic

        if (lista01 == null) {
            if (sJson.equals(""))
                sJson = _table1Controler.json()
            lista01 = JSON.parse<Array<dynamic>>(sJson)
        }

        //cabeçalho do grid
        Thead {
            Tr() {
                for (o in _lcol) {
                    if (o.tipo.equals("D") || o.tipo.equals("S") || o.tipo.equals("T") || o.tipo.equals("L"))
                        Th({ style { width(o.width.mm); textAlign("left") } }) { Text(o.titulo) }
                    else if (o.tipo.equals("N"))
                        Th({ style { width(o.width.mm); textAlign("right") } }) { Text(o.titulo) }
                    else if (o.tipo.equals("B"))
                        Th({ style { width(o.width.mm); textAlign("right") } }) { }
                }
            }
        }

        var sCampo = ""
        //var sCampoItem = ""
        var sResult = ""

        lista01!!.forEach {
            var textColor: CSSColorValue = Color.dimgray
            if (_tipo.equals("Black"))
                textColor = Color.gainsboro

            sResult = "${it["OO_CORLINHA"]}"
            if (sResult.equals("yellow"))
                textColor = Color.yellow
            if (sResult.equals(""))
                textColor = Color.gainsboro

            Tr({
                onClick { _ ->
                    _table1Controler.clickObj(lista01!!.indexOf(it).toString())
                }
                //iLinha += 1

            }) {
                for (o in _lcol) {
                    sCampo = o.campo.trim()
                    //sCampoItem = "${o.campo} ".replace("_1","").trim()
                    //println0("sCampo = $sCampo , sCampoItem = $sCampoItem")
                    //sCampoItem = "${o.campo} ".replace("_1","").trim()
                    sResult = "${it[sCampo]}"
                    if (sResult.equals("undefined"))
                        sResult = "-"

                    if (o.alterar.equals("N")) {
                        if (o.tipo.equals("D")) {
                            sResult = sResult.ffDsd().ffDdBr(2)
                        } else if (o.tipo.equals("T")) {
                            sResult = sResult.ffDsd().ffDtBr(2)
                        }

                        if (o.tipo.equals("L"))
                            Td({ style { width(o.width.mm); textAlign("left"); color(textColor) } }) { long(sResult) }

                        else if (o.tipo.equals("D") || o.tipo.equals("T") || o.tipo.equals("S"))
                            Td({ style { width(o.width.mm); textAlign("left"); color(textColor) } }) { ffSpan(sResult) }
                        else if (o.tipo.equals("N"))
                            Td({ style { width(o.width.mm); textAlign("right"); color(textColor) } }) { Text(sResult) }
                        else if (o.tipo.equals("B")) {
                            Td({ style { width(o.width.mm); } }) {
                                ffButton(
                                    o.titulo,
                                    lista01!!.indexOf(it),
                                    _table1Controler
                                )
                            }
                        }
                    } else if (o.alterar.equals("S")) { //campos que permite alteração
                        if (o.tipo.equals("S")) {
                            ff.println0("NumberInput aqui input_2")
                            val valor = remember { mutableStateOf(gsInput("ta1")) }
                            Td({ style { width(o.width.mm); } }) {
                                ffTextInput(valor, o.tipo, 0)
                            }
                            it[sCampo] = valor.text()
                        } else if (o.tipo.equals("N")) {
                            //ff.println0("NumberInput aqui input_1")
                            val valor = remember { mutableStateOf(gsInput("ta2")) }
                            Td({ style { width(o.width.mm); } }) {
                                //ffNumberInput(valor, o.tipo, 10)
                                ffInput44("", valor, o.tipo, 10, 0, false, _onFocusIn = {}, _onFocusOut = {})
                            }
                            if (!valor.text().equals("-"))
                                it[sCampo] = valor.text()
                        }
                    }
                }
            }
        }

    }

    @Composable
    private fun long(_text: String): Unit {

        val sTeste = _text.split("<br>")
        for (obj in sTeste) {
            Div { Text(obj) }
        }

    }

    @Composable
    private fun ffNumberInput(
        _valor: MutableState<String>,
        _tipoCampo: String,
        _max: Int
    ): Unit {

        var sKey = ""

        Input(type = InputType.Number,
            attrs = {
                classes("form-control")
                value(_valor.text())
                style { (textAlign("right")); fontSize(fontSmallTable) }
                onInput { _valor.text(it.value.toString()) }
                onChange { _valor.text(ffValidar(_valor.text(), _tipoCampo, _max)) }

                onKeyDown {
                    if ("Enter,Backspace,Delete".contains(it.getNormalizedKey())) {
                        _valor.key(it.getNormalizedKey()); ff.println0(it.getNormalizedKey())
                    } else if (!_valor.key().equals(""))
                        _valor.key("")
                }

            }
        )
    }


    @Composable
    private fun ffTextInput(
        _valor: MutableState<String>,
        _tipoCampo: String,
        _max: Int
    ): Unit {

        var sKey = ""

        return TextInput(value = _valor.text().ffVsVazio(),
            attrs = {
                classes("form-control")
                style { (textAlign("right")); fontSize(fontSmallTable) }
                onInput { _valor.text(it.value.toString()) }
                onChange { _valor.text(ffValidar(_valor.text(), _tipoCampo, _max)) }
                //onBeforeInput { _valor.value = ffValidar(_valor.value, _tipoCampo, _max) }
                //onFocusOut { _valor.value = ffValidar(_valor.value, _tipoCampo, _max) }
                //onInput { _valor.value = ffValidar(_valor.value, _tipoCampo, _max) }

                onKeyDown { sKey = it.getNormalizedKey() }
            })
    }

    @Composable
    private fun ffButton(_text: String, _registro: Int, _click: MutableState<String>) {

        Button({
            classes(
                "btn",
                "dlg-mobbt100",
                "btn-success",
                "btn-rounded"
            )
            style { textAlign("center"); fontSize(fontSmallTable) }
            onClick { _ ->
                _click.clickObj(_registro.toString())
                _click.clickTipo("Button")
            }

        }) { Text(_text) }
    }


}